export const storageKey = {
  quoteTermsActiveStep: 'quoteTermsActiveStep',
  quoteTermsData: 'quoteTermsData',
  createNewDealData: 'createNewDealData',
};
